import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import sessionService from '../../services/SessionService';
import { Button } from '../Common/Button';
import EventEmitter from 'eventemitter3';
import Events from './Events';
import { ContentPanel, Footer, Fullscreen, Section } from '../Common/Modal/Fullscreen';
import { LogoPanel } from '../Common';
import {
  FUNNEL,
  POWER_MODE,
} from '../../interfaces/ProductService.interface';
import { useIntl } from 'react-intl';
import { ShopSettingsContext } from '../../FootprintTech/AppController';
import log, { LogMode } from '../../services/LogService';
import { colors } from '../../theme';
import {version} from '../../../../package.json';
import OptionsComponent from './OptionsComponent';
import { SPEED_OPTION } from './interface';


// Define CSS variables
const Variables = {
  polly: '#e0ecf8',
  almond: '#fdf5ec'
};

interface InputSelectionProps {
  emitter: EventEmitter;
  funnel: FUNNEL;
}

const Text = styled.div`
  font: 700 3vh/1.36 Inter, sans-serif;
  margin-bottom: 25px;
`;

const Blank = styled.div`
  height:250px;
`;

const customCss = `

.fpt-modal {
  position: relative;
  overflow: auto;
}

.disclaimer {
  display: none;
}

`;

const InputSelection: React.FunctionComponent<InputSelectionProps> = (props) => {
  const { emitter } = props;
  const intl = useIntl();
  const speedOptions = 0, measureOptions = 1;
  const shopSettings = useContext(ShopSettingsContext);
  const { powerMode } = shopSettings;
  const [ selectedMeasureOption, setSelectedMeasureOption ] = useState('');
  const [ selectedSpeedOption, setSelectedSpeedOption ] = useState('');
  const [ currentOptions, setCurrentOptions ] = useState(
    powerMode === POWER_MODE.OPTIONAL ? speedOptions : measureOptions);
  const [ continueEnabled, setContinueEnabled ] = useState(false);

  const handleMeasureOptionSelect = (option:string) => {
    setSelectedMeasureOption(option);
    setContinueEnabled(true);
  };

  const handleSpeedOptionSelect = (option:string) => {
    setSelectedSpeedOption(option);
    setContinueEnabled(true);
  };

  const handleContinue = ev => {
    console.log('continue clicked');

    if (currentOptions === speedOptions) {
      setContinueEnabled(false);
      setCurrentOptions(measureOptions);
      emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    } else if(powerMode === POWER_MODE.NONE) {
      setCurrentOptions(measureOptions);
      emitter.emit(Events.onSpeedOptionConfirm, selectedSpeedOption);
    } else {
      emitter.emit(Events.onMeasureOptionConfirm, selectedMeasureOption);
    }
  }

  useEffect(() => {

    sessionService.updateExitCode('PDP', 'input-selection.displayed');
    emitter.addListener(Events.onMeasureOptionSelect, handleMeasureOptionSelect);
    emitter.addListener(Events.onSpeedOptionSelect, handleSpeedOptionSelect);
    emitter.addListener(Events.onContinuePress, handleContinue);

    log.info(`Power mode: ${powerMode}`);

    if (powerMode === POWER_MODE.MANDATORY) {
      setSelectedSpeedOption(SPEED_OPTION.FAST_TRACK);
      emitter.emit(Events.onSpeedOptionConfirm, SPEED_OPTION.FAST_TRACK);
    }

  }, []);

  useEffect(() => {
    log.info(`Switching current options to ${currentOptions}`);
  }, [currentOptions]);

  return (
    <Fullscreen
      emitter={emitter}
      isClosable={false}
      style={{
        backgroundImage: `linear-gradient(to bottom, ${Variables.polly}, ${Variables.almond})`,
      }}
    >
      <style>{customCss}</style>
      <LogoPanel />
      <ContentPanel>
        <OptionsComponent emitter={emitter} currentOptions={currentOptions} />
      </ContentPanel>
      <Footer className="disclaimer">
      { log.mode === LogMode.VERBOSE &&
        <Section>Driver version: {version}</Section>
      }
        <Section>
          <Button
            disabled={ continueEnabled ? false : true }
            onClick={handleContinue} type="button"
            className="wide-primary">
            <FormattedMessage id="lp.hartmann.input-selection.continue" />
          </Button>
        </Section>
      </Footer>
    </Fullscreen>
  )
};

export default InputSelection;
